import { ArchiveDialogProps } from "../components/PublicDialogs/ArchiveDialog"
import { ArchiveModel } from "../models/archive-model"

export function hideArchiveDialog() {
    return {
        type: "HIDE_Archive_DIALOG"
    }
}

export function showArchiveDialog(model: Partial<ArchiveModel>, onOk?: () => void) {

    return {
        type: "SHOW_Archive_DIALOG",
        diaolgData: {
            model,
            show: true,
            onOk
        }
    }
}

const initialState: ArchiveDialogProps = {
    model: new ArchiveModel(),
    show: false,
    onOk: undefined
}

export default function msgDialogReducer(archiveDialog = initialState, action:any) {
    switch (action.type) {
        case "SHOW_Archive_DIALOG":
            return action.diaolgData
        case "HIDE_Archive_DIALOG":
            return { ...initialState, Show: false }
        default:
            return archiveDialog
    }
}
